import { useAPI, useQuery, useMutation, APIInput } from '@mybonus/ui';
import { useState } from 'react';

export function useFaqGroupList() {
	const [deleteId, setDeleteId] = useState<number>();
	const [deletedIds, setDeletedIds] = useState<number[]>([]);
	const { api } = useAPI();

	const list = useQuery(
		'admin.faq.group.list',
		(args) => api.admin.faq.group.list.query(args),
		undefined,
		{ ttl: false },
	);

	const remove = useMutation<APIInput['admin']['faq']['group']['remove']>(
		(input) => api.admin.faq.group.remove.mutate(input),
	);

	const inactivate = useMutation<APIInput['admin']['faq']['group']['update']>(
		(input) => api.admin.faq.group.update.mutate(input),
		{
			onSuccess: () => list.load({ refetch: true, bypassCache: true }),
		},
	);

	function handleInactivate(id: number, active: boolean) {
		inactivate.mutate({ id, data: { active: !active } });
	}

	return {
		list,
		remove,
		inactivate,
		handleInactivate,
		deleteId,
		setDeleteId,
		deletedIds,
		setDeletedIds,
	};
}
